export default "__VITE_ASSET__BD2PsjYQ__"